<template>
  <div class="task-child">
    <div class="report-image-grid" v-if="!loading">
      <ArcheoHeritageSelect
        v-on:report-event="reportEvent($event)"
        :archeoHeritages="archeoHeritages"
        v-if="step===0"
      />
      <ReportTypeSelect v-on:report-event="reportEvent($event)" v-if="step===1" />
      <Hop3DSelect
        v-on:report-event="reportEvent($event)"
        :hops3DRelated="hops3DRelated"
        v-if="step===2"
      />
    </div>
    <div class="card-grid-item report-modal" v-else>
      <div class="block">
        <p class="circle">
          <span class="ouro ouro3">
            <span class="left">
              <span class="anim"></span>
            </span>
            <span class="right">
              <span class="anim"></span>
            </span>
          </span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { status_values, dash_tasks } from "../utils/env";
import ArcheoHeritageSelect from "./report/ArcheoHeritageSelect";
import ReportTypeSelect from "./report/ReportTypeSelect";
import Hop3DSelect from "./report/Hop3DSelect";
import axios from 'axios';

export default {
  name: "Report",
  components: {
    ArcheoHeritageSelect,
    ReportTypeSelect,
    Hop3DSelect
  },
  props: {
    task: { type: Object },
    header_status: { type: Object },
    footer_status: {type: Object},
    api: null,
    config: null
  },
  data: function() {
    return {
      status_values: status_values,
      dash_tasks: dash_tasks,
      archeoHeritages: [],
      data_in: [],
      hops3DRelated: [],
      status: null,
      heritage: null,
      report_type: null,
      hop3d: null,
      task_: this.task,
      header_status_: this.header_status,
      footer_status_: this.footer_status,
      loading: false,
      page_selected: 1,
      combo_initialized: false
    };
  },
  methods: {
    search: function() {
      this.load(true);
      let sector_ids = [];
      let area = null;
      if (
        this.header_status_.root_combo_filter &&
        this.header_status_.root_combo_filter !== ""
      ) {
        area = this.header_status_.combo_filter_values.filter(elem => {
          if (elem["value"] === this.header_status_.root_combo_filter.value)
            return true;
        });
        sector_ids = area[0]["children"].map(el => {
          return el["value"];
        });
      }
      console.log("SECTOR IDS : ", sector_ids);
      if (this.text_filter !== null) {
        this.api
          .findArheoHeritageResource(
            this.header_status_.root_combo_filter.value,
            this.header_status_.leaf_combo_filter.value,
            sector_ids,
            this.header_status_.text_filter,
            this.page_selected
          )
          .then(
            response => {
              var data = response.data;
              this.archeoHeritages = data["results"]["hits"]["hits"];
              this.footer_status_.paginator = data['paging-filter']['paginator']; 
              this.data_in = data;
              this.load(false);
            },
            error => {
              console.log(error);
              this.load(false);
            }
          );
      }
    },
    searchHops3DRelated: function() {
      this.load(true);
      this.api
        .findHops3DRelated(this.heritage["_source"]["resourceinstanceid"])
        .then(
          axios.spread((...responses) => {
            //var data = response.data;
            // var data_filtered = [];
            // data["related_resources"]["related_resources"].map(resource => {
            //   if (
            //     resource["graph_id"] ===
            //       this.config["archaeological_related_3dhops_graph_id"] &&
            //     (resource["displayname"].includes(this.textFilter) ||
            //       resource["displaydescription"].includes(this.textFilter) ||
            //       this.textFilter === "")
            //   ) {
            //     return data_filtered.push(resource);
            //   }
            // });
            // this.hops3DRelated = data_filtered;
            //this.hops3DRelated = data['results']['hits']['hits'];
            //console.log(this.hop3DSelected);
            this.hops3DRelated = [];
            for(let response of responses) {
              let data = response.data['tiles'][0]['data'];
              let display_values = response.data['tiles'][0]['display_values'];
              let title_node_id = null;
              let description_node_id = null;
              let image_preview_url_node_id = null;
              for(let dis_value of display_values) {
                switch(dis_value.label) {
                  case this.config.hope3d_title_label:
                    title_node_id = dis_value.nodeid;
                    break;
                  case this.config.hope3d_description_label:
                    description_node_id = dis_value.nodeid;
                    break;
                  case this.config.hope3d_image_preview_label:
                    image_preview_url_node_id = dis_value.nodeid;
                    break; 
                }
              }
              this.hops3DRelated.push({
                id: response.data['tiles'][0]['resourceinstance'],
                title: title_node_id?data[title_node_id]:'',
                description: description_node_id?data[description_node_id]:'',
                image_preview_url: (image_preview_url_node_id && data[image_preview_url_node_id] && data[image_preview_url_node_id].length>0)?data[image_preview_url_node_id][0]['url']:''
              });
            }
            this.load(false);
          },
          error => {
            console.log(error);
            this.load(false);
          }
        ));
    },
    searchAreaFilters: function() {
      this.load(true);
      this.api.findDropdownHeritageArea().then(
        response => {
          let data = response.data;
          let data_ = data.map(res => {
            let elem_ = { value: res["id"], key: res["text"] };
            elem_["children"] = res["children"];
            if ("children" in elem_ && elem_["children"].length > 0) {
              elem_["children"] = elem_["children"].map(childElem => {
                return { key: childElem["text"], value: childElem["id"] };
              });
            }
            return elem_;
          });
          this.header_status_.combo_filter_values = data_;
          this.header_status_.text_filter = ""; 
          this.header_status_.root_combo_filter = "";
          this.header_status_.leaf_combo_filter = "";
          this.$emit("dash-event", {
            topic: "header-status",
            header_status: this.header_status_
          });
          this.combo_initialized = true;
        },
        error => {
          console.log(error);
        }
      );
    },
    reportEvent: function(event) {
      switch (event.topic) {
        case "heritage-selected":
          this.heritage = event.heritage;
          this.step = 1;
          break;
        case "report-type-selected":
          if (event.report_type === "on-card") {
            let report_graph_id = this.config["report_graph_id"];
            let her_id = this.heritage._id;
            window.open(
              `/add-resource/${report_graph_id}?ddc65db2-69f0-11ea-be74-005056868262=${her_id}`,
              "_blank"
            );
          } else if (event.report_type === "on-cloud") {
            this.report_type = event.report_type;
            this.step = 2;
          }
          break;
        case "hop-selected":
          this.hop3d = event.hop;
          window.open(
            `/report/${event.hop["id"]}?herid=${this.heritage._id}`,
            "_blank"
          );
          break;
      }
    },
    hop3DSelected: function(value) {
      // Goto resource report with query herid as hop3d identificator
      let hop3d_id = value["id"];
      let her_id = this.heritage._id;
      this.hop3d = value;
      window.open(
        `/report/${hop3d_id}?herid=${her_id}`,
        "_blank"
      );
    },
    dashEvent: function(task) {
      this.$emit("dash-event", { topic: "task-selected", task: task });
    },
    load(value) {
      this.loading = value;
    }
  },
  computed: {
    step: {
      get() {
        return this.task_.workflow_current_index;
      },
      set(value) {
        this.task_.workflow_current_index = value;
        if (this.step == 0) this.searchAreaFilters();
        this.$emit("dash-event", {
          topic: "workflow-current-index",
          workflow_current_index: value
        });
      }
    }
  },
  watch: {
    step: function() {
      if (this.step === 0) {
        this.heritage = null;
        this.combo_initialized = false;
        this.searchAreaFilters();
        // this.search();
      } else if (this.step === 1) {
        this.textFilter = "";
        this.report_type = null;
      } else if (this.step === 2) {
        this.hop3d = null;
        this.textFilter = "";
        this.searchHops3DRelated();
      }
    },
    header_status: {
      handler() {
        if  (this.step === 0 && this.combo_initialized) this.search();
      },
      deep: true
    },
    footer_status: {
      handler() {
        if( (this.footer_status) &&
            ('page_selected' in this.footer_status) &&
            (this.footer_status.page_selected !== this.footer_status_.page_selected)) {
              this.search();
            }
      },
      deep: true
    }
  },
  mounted: function() {
    this.step = 0;
  }
};
</script>

<style scoped>
.workflow-child {
  min-height: 240px;
  padding-left: 60px;
}

.panel-heading {
  height: 50px;
  margin-top: 0px !important;
  padding: 2px 2px 2px 2px;
  background-color: #ffffff;
  border-width: 0px 0px 0px 0px;
  border-style: solid;
  border-color: #ffffff;
}

.panel-footer {
  border-width: 0px 0px 0px 0px;
  border-color: #000000;
  border-style: solid;
}

.panel-body {
  border: 1px solid;
  border-color: #9e5757;
}

button.btn {
  margin: 10px;
  float: left;
}

.panel-heading button {
  float: left;
  margin: 4px;
}

.panel-heading > a {
  border-width: 0px 0px 0px 1px;
  border-color: #ffffff;
  border-style: solid;
}

.panel-heading > div {
  border-width: 0px 0px 0px 0px;
  border-color: #ffffff;
  border-style: solid;
}

.panel-heading > div > a {
  height: 30px;
  padding: 4px 6px;
}
.panel-heading button.btn {
  top: 4px;
  padding: 4px 4px 4px 4px;
}

.form-control {
  max-width: 160px;
  margin-left: 4px;
}

div.well {
  padding: 4px 4px 4px 4px;
  max-height: 36px;
  width: 400px;
  margin: 2px 2px 2px 2px;
  vertical-align: middle;
  font-size: 16px;
}

div.well > * {
  max-height: 36px;
  margin: 4px 4px 4px 4px;
}

div[class^="col-"] {
  padding: 2px 2px 2px 2px;
}

div#app .form-control {
  max-width: 100%;
}

.card-grid-item {
  width: 400px;
  text-overflow: ellipsis;
  word-wrap: break-word;
  padding-bottom: 0px;
}
.car-grid-item * {
  display: block;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.panel-body {
  min-height: 251px;
}

.addScroll {
  overflow-y: auto;
  height: 200px;
}

.card-grid-item.report-modal {
  min-height: 240px;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.1);
  text-align: center;
  display: table;
  width: 100%;
  border: 0px;
}

#app .block {
  display: table-cell;
  vertical-align: middle;
  background-color: rgba(255, 255, 255, 0.1);
}
</style>

